import React, { useState } from 'react';
import { Check, Close } from '@icon-park/react';
import { useTranslation } from 'react-i18next';

interface DoorPropertyPanelProps {
  position: { x: number; y: number };
  initialHeight?: number;
  initialOpenAngle?: number;
  onConfirm: (data: { height: number; openAngle: number }) => void;
  onCancel: () => void;
}

const DoorPropertyPanel: React.FC<DoorPropertyPanelProps> = ({
  position,
  initialHeight = 2100,
  initialOpenAngle = 90,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();
  const [height, setHeight] = useState(initialHeight);
  const [openAngle, setOpenAngle] = useState(initialOpenAngle);

  const handleConfirm = () => {
    onConfirm({ height, openAngle });
  };

  return (
    <div
      className="absolute bg-white rounded shadow-lg border border-gray-300 p-2 z-50"
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
        width: '180px',
      }}
    >
      <h3 className="text-sm font-medium text-gray-900 mb-2">{t('elementProps.doorProps')}</h3>
      <div className="text-xs text-gray-500 mb-2">{t('elementProps.widthFromWall')}</div>

      {/* 尺寸设置 */}
      <div className="mb-2">
        <label className="block text-xs text-gray-600 mb-0.5">
          {t('elementProps.height')}
        </label>
        <input
          type="number"
          value={height}
          onChange={(e) => setHeight(Number(e.target.value))}
          className="w-full px-1.5 py-0.5 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-primary-300"
          min="1800"
          max="2400"
          step="50"
        />
      </div>

      <div className="mb-2">
        <label className="block text-xs text-gray-600 mb-0.5">
          {t('elementProps.openAngle')}
        </label>
        <input
          type="number"
          value={openAngle}
          onChange={(e) => setOpenAngle(Number(e.target.value))}
          className="w-full px-1.5 py-0.5 text-xs border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-primary-300"
          min="45"
          max="180"
          step="15"
        />
      </div>

      {/* 操作按钮 */}
      <div className="flex gap-1">
        <button
          onClick={handleConfirm}
          className="flex-1 flex items-center justify-center gap-0.5 px-1.5 py-0.5 bg-primary-500 text-white text-xs rounded hover:bg-primary-600 transition-colors"
        >
          <Check size={12} theme="outline" />
          <span className="text-[10px]">{t('dialog.confirm')}</span>
        </button>
        <button
          onClick={onCancel}
          className="flex-1 flex items-center justify-center gap-0.5 px-1.5 py-0.5 bg-gray-200 text-gray-700 text-xs rounded hover:bg-gray-300 transition-colors"
        >
          <Close size={12} theme="outline" />
          <span className="text-[10px]">{t('dialog.cancel')}</span>
        </button>
      </div>
    </div>
  );
};

export default DoorPropertyPanel;
